import { EarlyAccessFeatures, LoginMethodType, MultiFactorType } from 'app/core/identity/user-identity';
import { SiteRole } from 'app/core/identity/site-role';

export interface UserModel {
  fullName?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  isAdmin?: boolean;
  language?: UserLanguage;
  timeZoneId?: string;
  accounts?: string[];
  darkMode: DarkMode;
  uiPreferences?: string;
  siteIds?: number[];
  /** The role on each site; empty from a gateway that does not list roles yet. */
  sites?: SiteRole[];
  hasEarlyAccess: boolean;
  earlyAccessFeatures: EarlyAccessFeatures[];
  hasMultiFactorAuthentication: boolean;
  multiFactorType: MultiFactorType;
  loginMethod?: LoginMethodType;
}

export enum UserLanguage {
  Swedish = 'Swedish',
  English = 'English',
}

export interface TimeZoneModel {
  id?: string;
  displayName?: string;
}

export enum DarkMode {
  DeviceSettingsBased = 'DeviceSettingsBased',
  AlwaysDark = 'AlwaysDark',
  AlwaysLight = 'AlwaysLight',
}
